<template>
  <v-dialog
    v-model="isOpen"
    max-width="1200"
    scrollable
    content-class="insSummaryDialog"
  >
    <v-card>
      <v-card-title class="pa-0 ma-0">
        <div class="pa-4">Hypothetical Insurance Summary</div>
        <v-simple-table class="stickyTable">
          <template v-slot:default>
            <thead>
              <tr class="secondary darken-1">
                <th colspan="4" class="grey--text text--lighten-3 text-center secondary darken-1">INITIAL INSURANCE INFO</th>
                <th colspan="4" class="grey--text text--lighten-3 text-center secondary darken-1">CAPITAL OPTIMIZATION</th>
                <th colspan="2" class="grey--text text--lighten-3 text-center secondary darken-1">LOAN INFORMATION</th>
              </tr>
              <tr class="secondary">
                <th class="white--text text-center secondary">Policy Year</th>
                <th class="white--text text-center secondary">Age</th>
                <th class="white--text text-center secondary">Annual Premium</th>
                <th class="white--text text-center secondary">Death Benefit</th>
                <th class="white--text text-center secondary">Increased Cash Value</th>
                <th class="white--text text-center secondary">EOY Cash Values</th>
                <th class="white--text text-center secondary">EOY Mo. Tailwind</th>
                <th class="white--text text-center secondary">Savings Account</th>
                <th class="white--text text-center secondary">From Policy</th>
                <th class="white--text text-center secondary">EOY Loan Balance</th>
              </tr>
            </thead>
          </template>
        </v-simple-table>
      </v-card-title>
      <v-card-text class="px-0">

        <v-simple-table class="stickyTable">
          <template v-slot:default>
            <tbody>
              <tr
                v-for="(summary, year) in yearlySummary"
                :key="'summary-year-' + year"
                :class="{'yellow': year == year70}"
              >
                <td>
                  {{ year }}
                </td>
                <td>
                  <div
                    v-for="(policy, policyId) of summary.policies"
                    :key="'summary-year-' + year + '-policy-age-' + policyId"
                  >
                    {{ policy.age }}
                  </div>
                </td>
                <td>
                  <div
                    v-for="(policy, policyId) of summary.policies"
                    :key="'summary-year-' + year + '-policy-prem-' + policyId"
                    class="currency"
                  >
                    {{ policy.premium | numberRounded }}
                  </div>
                </td>
                <td>
                  <div
                    v-for="(policy, policyId) of summary.policies"
                    :key="'summary-year-' + year + '-policy-deathben-' + policyId"
                    class="currency"
                  >
                    {{ policy.death_ben_end | numberRounded }}
                  </div>
                </td>
                <td>
                  <div
                    v-for="(policy, policyId) of summary.policies"
                    :key="'summary-year-' + year + '-policy-cashvalinc-' + policyId"
                    class="currency"
                  >
                    {{ (policy.cash_val_end - policy.cash_val_start) | numberRounded }}
                  </div>
                </td>
                <td>
                  <div
                    v-for="(policy, policyId) of summary.policies"
                    :key="'summary-year-' + year + '-policy-cashval-' + policyId"
                    class="currency"
                  >
                    {{ policy.cash_val_end | numberRounded }}
                  </div>
                </td>
                <td class="currency">
                  {{ summary.tailwind | numberRounded }}
                </td>
                <td class="currency">
                  {{ summary.savings | numberRounded }}
                </td>
                <td>
                  <div
                    v-for="(policy, policyId) of summary.policies"
                    :key="'summary-year-' + year + '-policy-loandraw-' + policyId"
                    class="currency"
                  >
                    {{ policy.loan_draw | numberRounded }}
                  </div>
                </td>
                <td>
                  <div
                    v-for="(policy, policyId) of summary.policies"
                    :key="'summary-year-' + year + '-policy-loanbal-' + policyId"
                    class="currency"
                  >
                    {{ policy.loan_bal_end | numberRounded }}
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn small color="secondary" @click="close()">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'InsuranceSummaryDialog',
  data() {
    return {
      isOpen: false,
      yearlySummary: [],
      renderTable: false
    }
  },
  computed: {
    year70() {
      for(let i = 0; i < Object.keys(this.yearlySummary).length; i++) {
        let key       = Object.keys(this.yearlySummary)[i];
        let summary   = this.yearlySummary[key]
        for(let i2 = 0; i2 < Object.keys(summary.policies).length; i2++) {
          let key2    = Object.keys(summary.policies)[i2]
          let policy  = summary.policies[key2]
          if(policy.age == 70) return key
        }
      }
      return null
    }
  },
  methods: {
    open(summary) {
      if(!summary) return
      this.renderTable = false
      this.yearlySummary = summary
      this.isOpen = true
      this.renderTable = true
    },
    close() {
      this.isOpen = false
    }
  }
}
</script>

<style lang="scss">
  .insSummaryDialog .stickyTable {
    width: 100%;
    table {
      width: 100%;
      th {
        word-break: break-word;
      }
      tbody > tr,
      thead > tr:nth-child(2) {
        td,th {
          width: 130px;
        }
        td:nth-child(1), th:nth-child(1) {
          width: unset;
        }
        td:nth-child(2), th:nth-child(2) {
          width: 60px;
        }
      }
    }
  }
</style>